<template>
  <div :class="`status ${setStatusColor()}`" @click="setStatus"></div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
export default {
    name: 'Status',
    props: {
        online: {
            type: [Number, Boolean],
            default: () => 0
        },
        status: {
            type:Object,
            default: () => ({})
        },       
        deviceId: {
            type: String,
            default: () => ''
        },       
        teamviewerId: {
            type: String,
            default: () => ''
        }
    },
    computed: {
        ...mapGetters({
            deviceStatus: 'getDeviceStatus'
        })
    },
    methods: {
        ...mapActions(['setDeviceStatus', 'getDeviceStatusData']),
        async setStatus () {
            const device = {};
            device.deviceId = this.deviceId;
            device.teamviewerId = this.teamviewerId;
            device.data = await this.getDeviceStatusData({ id: this.deviceId });
            this.setDeviceStatus([device]);
            this.$modal.show('status');
        },
        setStatusColor () {
            if (!this.online) {
                return 'empty';
            }
            const { deviceError } = this.status;
            return !!deviceError && deviceError !== false ? 'error' : 'success';
        }
    }
};
</script>

<style scoped lang="scss" >
.status {
  display: table;
  margin: 0 auto;
  height: 20px;
  width: 20px;
  &:hover {
    border: 2px solid black;
  }
  border-radius: 0;
  background-color: lightgray;

  &.error {
    background-color: red;
  }
  &.empty {
    background-color: #eac800;
  }
  &.success {
    background-color: green;
  }
}
</style>
